export function renderPublicPageLayout(conteudo: string): string {
    return (`
        <div style="
            margin: 0;
            padding: 0;
            min-height: 100vh;
            height: 100%;
            overflow: auto;
            background: #F8F8F8;
            font-family: sans-serif;
            color: #363632;"
        >
            <header style="
                background-color: #FFFFFF;
                border-bottom: 1px solid #DDDDDD;"
            >
                <nav style="
                    padding: 9px 15px 12px 15px;
                    display: flex;
                    align-items: center;
                    justify-content: center;"
                >
                    <img
                        src="https://s3.sa-east-1.amazonaws.com/imagens.nasajon/logos/sistemas-web/versao-padrao/icone-mais-nome/icn-nome-meurh.svg"
                        alt="Nasajon"
                        style="height: 45px; width: 85px;"
                    >
                </nav>
            </header>

            <main style="padding: 12px 16px;">${conteudo}</main>
        </div>
    `);
}
